export const server = "https://server.deenovoschool.com/api/v1";
// export const server = "http://localhost:7878/api/v1";
